import React, { useState, useEffect } from "react";
import { Button, Header, Icon, Table } from 'react-frontier2';
import { PromoterContact } from "../../AdminClasses";
import { bindClick } from "@arema/components/Util";
import { useTranslation } from "react-i18next";
import API from "../../API";
import PromoterContactModal from './PromoterContactModal';
import libphone from 'libphonenumber-js'

interface Props {
	promoter_id?: number,
	onEditPromoter?: Function,
}

var PromoterContactsList = (props: Props)=>{
	var { t } = useTranslation();
	var [contacts, setContacts] = useState<PromoterContact[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [viewingContact, setViewingContact] = useState<PromoterContact>(null);
	var [createModal, setCreateModal] = useState<boolean>(false);

	var loadContacts = ()=>{
		API.getPromoterContacts(props.promoter_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setContacts(res.data);
		}).catch(err=>{
			setLoadError(t('common.unexpected_code', { code: 'LCL-PRMCTL-LD-1' }));
		});
	}

	useEffect(()=>{
		if(!contacts){
			loadContacts();
		}
	}, []);

	const onSaveContact = (contact: PromoterContact) => {
		setCreateModal(false);
		var cts = [...contacts];
		var ix = cts.findIndex(a=>a.contact_id==contact.contact_id);
		if(ix==-1){
			cts.push(contact);
		}else{
			cts[ix] = contact;
		}
		setContacts(cts);
	}

	var showCreate = ()=>{
		setViewingContact(null);
		setCreateModal(true);
	}

	var onDeleteContact = (contact_id: number)=>{
		setCreateModal(false);
		setContacts(contacts ? contacts.filter(a=>a.contact_id!==contact_id) : []);
	}

	if(loadError) return <Header text={t('common.error')} subtext={loadError} />
	if(!contacts) return <Header loading text={t('common.loading')} />

	return <>
		<Table style={{ maxWidth: 800 }}>
			<Table.Head
				title={t('promoter_contacts.title')}
				collapsingIndexes={[0, 2, 4]}
				data={[t('promoter_contacts.headers', { returnObjects: true })]}
				titleRight={(
					<Button size="tiny" color="black" iconName="plus-circle" text={t('common.create')} onClick={showCreate} />
				)}
			/>
			<Table.Body>
				{contacts.length===0 && (
					<Table.Cell empty row colSpan={100} value={t('promoter_contacts.empty')} />
				)}
				{contacts.map(a=>(
					<Table.Row
						selectable
						onClick={bindClick(setViewingContact, a)}
						collapsingIndexes={[0, 2, 4]}
						data={[
							a.contact_id,
							a.contact_name,
							a.department,
							a.email,
							a.phone ? libphone(a.phone, 'MX').format('NATIONAL') : <Icon name="minus" color="gray" />
						]}
					/>
				))}
			</Table.Body>
		</Table>
		<PromoterContactModal 
			open={createModal || !!viewingContact} 
			promoterId={props.promoter_id} 
			contact={viewingContact} 
			onClose={()=>{
				setCreateModal(false);
				setViewingContact(null);
			}} 
			onSaveContact={onSaveContact} 
			onDeleteContact={onDeleteContact}
		/>
	</>
}

export default PromoterContactsList;